import React from 'react';
import { motion } from 'framer-motion';
import KiaanButton from './KiaanButton';
import farmingPartner from '../Assets/Images/farming-partner.png';

const HowItWorks = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-green-100 to-green-300" id="partnership">
      <div className="container mx-auto px-4">
        {/* How the farming partnership works */}
        <motion.div
          className="max-w-6xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <img
            src={farmingPartner}
            alt="How the farming partnership works — from joining to harvest in 5 simple steps, crop cycle timeline, and what Kiaan manages on your behalf"
            className="w-full h-auto rounded-2xl ring-1 ring-green-900/10 shadow-[0_20px_50px_-10px_rgba(2,58,16,0.35),0_0_25px_rgba(2,58,16,0.12)]"
          />
        </motion.div>

        {/* CTA */}
        <motion.div
          className="text-center mt-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <KiaanButton href="#contact">
            <span className="relative z-10 font-semibold text-green-950">Become a Farming Partner</span>
          </KiaanButton>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
